import { Button, Typography } from '@breetometer/components';
import { CopyIcon, DownloadIcon, ReportIcon, ResolveIcon, ShareIcon } from 'BreetAssets';
import { copyToClipboard, openIntercom } from 'BreetHelpers';

import { type IEngagementActions, shareContent } from './EngagementActions.helpers';

const EngagementActions = ({
	isResolve,
	onResolve,
	shareContentDetails,
	intercomOpenMessage,
	noReport,
	isCopy,
	copy,
}: IEngagementActions) => (
	<div
		className='engagement'
		data-testid='engagement-actions'
	>
		<Button
			variant='native'
			className='engagement_item'
			onClick={shareContentDetails?.downloadFn ?? shareContent(shareContentDetails)}
		>
			{shareContentDetails?.action === 'share' ? (
				<ShareIcon className='svg-dark svg-dark-outline' />
			) : (
				<DownloadIcon className='svg-dark svg-dark-outline' />
			)}
			<Typography className='color-primary-50'>{shareContentDetails?.action === 'share' ? 'Share' : 'Download'}</Typography>
		</Button>

		{isResolve && (
			<Button
				variant='native'
				className='engagement_item'
				onClick={onResolve}
			>
				<ResolveIcon className='svg-dark svg-dark-outline' />
				<Typography className='color-primary-50'>Resolve</Typography>
			</Button>
		)}

		{!noReport && (
			<Button
				variant='native'
				className='engagement_item'
				onClick={openIntercom(intercomOpenMessage)}
			>
				<ReportIcon className='svg-dark svg-dark-outline' />
				<Typography className='color-primary-50'>Report</Typography>
			</Button>
		)}

		{isCopy && (
			<Button
				variant='native'
				className='engagement_item'
				onClick={copy?.copyFn ?? copyToClipboard(copy?.item, copy?.message)}
			>
				<CopyIcon
					variant='asset'
					className='svg-dark svg-dark-outline'
				/>
				<Typography className='color-primary-50'>Copy</Typography>
			</Button>
		)}
	</div>
);

export default EngagementActions;
